(function () {
    'use strict';
    angular
        .module('chamadosApp')
        .factory('Equipe', Equipe);

    Equipe.$inject = ['$resource'];

    function Equipe($resource) {
        var resourceUrl = 'api/equipes/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'save': {method: 'POST'},
            'update': {method: 'PUT'},
            'delete': {method: 'DELETE'}
        });
    }
})();
